

// const BASE_URL = "http://127.0.0.1:8000/api/v1";

const BASE_URL = "/api/v1";

export async function uploadVideo(file) {
  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch(`${BASE_URL}/video/upload`, {
    method: "POST",
    body: formData,
  });

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return response.json();
}


export async function uploadLiveVideo(file) {

  const formData = new FormData();

  formData.append("file", file);

  const response = await fetch(
    `${BASE_URL}/video/upload/live`,
    {
      method: "POST",
      body: formData,
    }
  );

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return response.json();
}

export async function getVideoStatus(videoId) {
  const response = await fetch(
    `${BASE_URL}/video/${videoId}/status`
  );

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return response.json();
}

// export async function chatWithVideo(videoId, query) {
//   const response = await fetch(
//     `${BASE_URL}/rag_user_query`,
//     {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         video_id: videoId,
//         query,
//       }),
//     }
//   );

//   if (!response.ok) {
//     throw new Error(await response.text());
//   }

//   return response.json();
// }


export async function chatWithVideo(videoId, videoS3Path, query, isLive = false) {

  const body = { query };

  if (videoId) body.video_id = videoId;
  if (videoS3Path) body.video_s3_path = videoS3Path;

  const endpoint = isLive
    ? "/real_time_video_analysis"
    : "/rag_user_query";

  const response = await fetch(
    `${BASE_URL}${endpoint}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    }
  );

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return response.json();
}

// export async function chatWithVideo(videoId, videoS3Path, query) {

//   const body = { query };

//   if (videoId) {
//     body.video_id = videoId;
//   }

//   if (videoS3Path) {
//     body.video_s3_path = videoS3Path;
//   }

//   const response = await fetch(
//     `${BASE_URL}/real_time_video_analysis`,
//     {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(body),
//     }
//   );

//   if (!response.ok) {
//     throw new Error(await response.text());
//   }

//   return response.json();
// }

export async function getVideoPreview(videoId, source = "library") {

  const response = await fetch(
    `${BASE_URL}/video/${videoId}/preview?source=${source}`
  );

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return response.json();
}

export async function getTranscript(videoId) {

  const res = await fetch(

    `${BASE_URL}/video/${videoId}/transcript`

  );

  return await res.json();

}

export async function chatWithIndexedVideo(videoId, query) {

  const response = await fetch(
    `${BASE_URL}/rag_user_query`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        video_id: videoId,
        query: query,
        // top_k: 5
        top_k: 1
      }),
    }
  );

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return response.json();
}


export async function getLibraryVideos() {

  const response = await fetch(
    `${BASE_URL}/library/videos`
  );

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return response.json();
}


// export async function chatWithLibrary(query) {

//   const response = await fetch(
//     `${BASE_URL}/rag_user_query`,
//     {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         query,
//         top_k: 5
//       }),
//     }
//   );

//   if (!response.ok) {
//     throw new Error(await response.text());
//   }

//   return response.json();
// }

export async function chatWithLibrary(query, videoId = null) {

  const body = {
    query,
    top_k: 1
  };

  if (videoId) {
    body.video_id = videoId;
  }

  const response = await fetch(
    `${BASE_URL}/rag_user_query`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    }
  );

  return response.json();
}